/* eslint-disable @typescript-eslint/no-explicit-any */
import { type Trello } from "../types/trello"
import { openLogTimePopup } from "./popup"

export async function getLogTimeCardButton(
  t: Trello.PowerUp.IFrame,
  props: any
): Promise<Trello.PowerUp.CardButton[]> {
  return [
    {
      icon: props.baseUrl + props.logo.light,
      text: "Log time",
      callback: (t: Trello.PowerUp.IFrame) => openLogTimePopup(t)
    }
  ]
}
